import NotificationsEmptyPlaceholder from './NotificationsEmptyPlaceholder';

export default NotificationsEmptyPlaceholder;
